import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'app.components.reAuthenticate.pageTitle',
        defaultMessage: 'Reauthenticate by entering admin password below'
    },
    password: {
        id: 'app.components.reAuthenticate.password',
        defaultMessage: 'Password'
    },
    continue: {
        id: 'app.components.reAuthenticate.continue',
        defaultMessage: 'Continue'
    }
});



// WEBPACK FOOTER //
// ./app/components/authentication/messages.js